import React from "react";
import { Variant } from "@components/buttons/Button/Button";
import BasePricingCard from "../BasePricingCard/BasePricingCard";
import styles from "./SubscriptionPricingCard.module.css";

type SubscriptionPricingCardProps = {
    title: string;
    features?: string[];
    boldedFeatures?: string[];
    price: number;
    period?: "month" | "year";
    oldPrice?: number;
    buttonText: string;
    onButtonClick: () => void;
    note?: string; // To handle the "Billed Annually" note
    variant?: Variant;
    isPopular?: boolean;
    disableButton?: boolean;
};

const SubscriptionPricingCard: React.FC<SubscriptionPricingCardProps> = ({
    title,
    features = [],
    boldedFeatures = [],
    price,
    period = "month",
    oldPrice,
    buttonText,
    onButtonClick,
    note,
    variant = "submit",
    isPopular,
    disableButton,
}) => {
    return (
        <div className={styles.cardWrapper}>
            {isPopular && (
                <div className={styles.ribbonWrapper}>
                    <div className={styles.ribbon}>Most Popular</div>
                </div>
            )}
            <BasePricingCard
                title={title}
                buttonText={buttonText}
                onButtonClick={onButtonClick}
                variant={variant}
                disableButton={disableButton}
            >
                {features.length > 0 && (
                    <ul className={styles.features}>
                        {boldedFeatures.map((feature, index) => (
                            <li className={styles.boldedFeatures} key={index}>{feature}</li>
                        ))}
                        {features.map((feature, index) => (
                            <li key={index}>{feature}</li>
                        ))}
                    </ul>
                )}

                <div className={styles.priceSection}>
                    {oldPrice && (
                        <div className={styles.oldPrice}>
                            $
                            {oldPrice}
                            /
                            {period}
                        </div>
                    )}
                    <div className={styles.price}>
                        $
                        {price}
                        /
                        {period}
                    </div>
                    {note && <div className={styles.note}>{note}</div>}
                </div>
            </BasePricingCard>
        </div>
    );
};

export default SubscriptionPricingCard;
